import React from 'react';
import './index.css';

const CenteredLayout = ({ children }) => {
  return <div className='centered'>{children}</div>;
};

export default CenteredLayout;
